import React from 'react'
import {
  LayoutBand,
  H1,
  Subheading,
  Grid,
  Separator,
  usePageWidth,
  H2,
  BillboardText,
  colors,
  Image,
  Bleed,
} from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import topSectionImage from './images/top-section-img.webp'
import topSectionImageMobile from './images/top-section-image-mobile.webp'
import AncestorSearch from '../AncestorSearch'

export default function TopSection() {
  const { t } = useTranslation()
  const atPageWidth = usePageWidth()
  const isMobile = atPageWidth({ default: true, xl: false })
  return (
    <LayoutBand color={colors.blue02} marginX="xl" style={{ overflow: 'hidden' }}>
      <Grid>
        <div columns={atPageWidth({ default: 12, xl: 7, xxl: 5 })} style={{ zIndex: 2 }}>
          {isMobile && (
            <Bleed sides>
              <Image
                src={topSectionImageMobile}
                alt={t(
                  'nlihp.united-states.top-section.image-alt',
                  'Woman holding her granddaughter and laughing while looking at a photo album'
                )}
              />
            </Bleed>
          )}
          <Separator size={isMobile ? 'xs' : 'xl'} />
          <BillboardText primaryColor={colors.blue90} secondaryColor={colors.blue90}>
            <H1 size="H3" centered={isMobile} balanced={isMobile}>
              {t('nlihp.united-states.top-section.heading', 'What will you discover about your ancestors?')}
              <Separator size={isMobile ? 'xs' : 'sm'} />
              <Subheading>
                {t(
                  'nlihp.united-states.top-section.subheading',
                  'Search billions of ancestor profiles, photographs, and historical documents at once—absolutely FREE.'
                )}
              </Subheading>
            </H1>
          </BillboardText>
          <Separator size="xl" />
          <BillboardText primaryColor={colors.blue90} secondaryColor={colors.blue80}>
            <H2 id="ancestor-info-heading" size={isMobile ? 'H6' : 'H5'}>
              {t('nlihp.united-states.top-section.enter-ancestor-information', 'Enter your ancestor information:')}
              <Subheading id="ancestor-info-subheading">
                {t(
                  'nlihp.united-states.top-section.ancestor-information.description',
                  'Not sure who to search for? Try a grandparent or great-grandparent.'
                )}
              </Subheading>
            </H2>
          </BillboardText>
          <Separator size="sm" />
          <AncestorSearch showLabels color="red" ariaDescribedBy="ancestor-info-heading ancestor-info-subheading" />
          <Separator size="xl" />
        </div>
        {!isMobile && (
          <Bleed top bottom end start columns={atPageWidth({ default: 12, xl: 5, xxl: 7 })} style={{ zIndex: 1 }}>
            <Image
              src={topSectionImage}
              alt={t(
                'nlihp.united-states.top-section.image-alt',
                'Woman holding her granddaughter and laughing while looking at a photo album'
              )}
              positionX="left"
              style={{ width: 'calc(100% + 250px)', marginInlineStart: atPageWidth({ xl: '-250px', xxl: '-100px' }) }}
            />
          </Bleed>
        )}
      </Grid>
    </LayoutBand>
  )
}
